import * as MainViewActions from './main-view.actions'

export {MainViewActions}